import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { HeaderContext } from 'app/containers/Header'
import { theme } from 'app/theme'
import { useVocabularyData } from 'app/utils/vocabulary'
import { rgba } from 'emotion-rgba'
import { Link } from 'gatsby'
import React, { memo, useContext } from 'react'

interface Props {
  quotationURL?: string
}

export const Toolbar = memo(function Toolbar({ quotationURL }: Props) {
  const { languageCode, languagePrefix } = useContext(HeaderContext) as any

  return (
    <Container dial={5} row space="between" stretch>
      {quotationURL ? (
        <Button to={quotationURL}>
          {useVocabularyData('ask', languageCode)}
        </Button>
      ) : null}

      <Anchor
        href={`https://www.simplebooking.it/ibe2/hotel/1628?lang=${languagePrefix || 'it'}`}
        rel="noopener"
        target="_blank"
      >
        {useVocabularyData('book', languageCode)}
      </Anchor>
    </Container>
  )
})

const Container = styled(FlexBox)`
  width: 100%;
  box-shadow: ${rgba(theme.colors.variants.neutralDark1, 0.1)} 0 0.0625rem
    1.25rem;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 20;
`

const Style = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  flex: 2;
  font-family: ${theme.fontFamily.heading};
  font-size: 0.875rem;
  line-height: 1.125rem;
  text-transform: uppercase;
`

const Button = styled(Link)`
  ${Style}

  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  color: ${({ theme }) => theme.colors.variants.primaryDark};
`

const Anchor = styled.a`
  ${Style}

  background: ${({ theme }) => theme.colors.variants.primaryDark};
  color: ${({ theme }) => theme.colors.variants.neutralLight1};
`
